window.$catalog_area_result = [];
window.$catalog_area_didUpdateChange = true;
window.$catalog_area_treeChangeStatus = false;
window.$catalog_area_treeList = [];
window.$catalog_area_page_number = 1;
window.$catalog_area_newInsertId = [];
window.$catalog_area_Glist = [];
window.$catalog_area_content = [];
window.$catalog_area_algemeenCode = [];
window.$catalog_area_algemeenNaam = [];
window.$catalog_area_discipline_naam = [];
window.$catalog_area_selectedRow = [];
window.$catalog_area_gvv = 1;
window.$catalog_area_filterMaatregelenIsActive = [];
window.$catalog_area_filterPlannigIsActive = [];
window.$catalog_area_filterContent = [];
window.$catalog_area_filterClickStatus = false;
window.$catalog_area_scroll_change = false;
window.$catalog_area_columnList = [];
window.$catalog_area_selectedIds = null;
window.$catalog_area_token = null;
window.$catalog_area_gebruiker_page_number = 1;
window.$catalog_area_gebruiker_table_total_row_count = 0;
window.$catalog_area_columnListPure = null;
window.$catalog_area_refresh = function(){};
window.$catalog_area_lastUsedTableFilter = {
  content: [],
  definitions: [],
};

window.$catalog_area_actions = [
  {
    id: "eb2f63ee-2ed8-4692-8dd4-28f951cbecbe",
    text: "Koppelen gebruiker aan gebied",
    class: "locate",
    modal: "koppelen_gebruiker_aan_gebied",
  },
  {
    id: "0a716b4a-f3a7-4891-8b06-2bc973c92a6a",
    text: "Koppelen discipline aan gebied",
    class: "locate",
    modal: "koppelen_discipline_aan_gebied",
  },
];

window.$catalog_area_column_order_post_model = {
  client_identification: "",
  code: "",
  data: {
    table_sorting: [
      {
        name: "catalog>area",
        column_list: [
          "checkbox",
          "active",
          "Naam",
          "Code",
          "Omschrijving",
          "Discipline naam",
        ],
      },
    ],
  },
};
